import React, { useState, useEffect } from 'react';
import inspectionStorage from '../services/inspectionStorage';
import syncManager from '../services/syncManager';
import pendingPhotosService from '../services/pendingPhotosService';
import SourceBTModalMobile from './modals/SourceBTModalMobile';
import DisjoncteurModalMobile from './modals/DisjoncteurModalMobile';
import { buildStandardEnedisSourceBT, buildStandardEnedisDisjoncteur } from '../presets/standardEnedisBranchement';
import SourceHTModalMobile from './modals/SourceHTModalMobile';
import SourceAutonomeModalMobile from './modals/SourceAutonomeModalMobile';
import ObservationModal from './modals/ObservationModal';
import QuickPhotoButton from './QuickPhotoButton';

const styles = {
  container: { minHeight: '100vh', background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)', paddingBottom: '100px' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', background: 'white', borderBottom: '1px solid #e2e8f0', position: 'sticky', top: 0, zIndex: 100 },
  backBtn: { background: 'none', border: 'none', fontSize: '16px', color: '#3b82f6', cursor: 'pointer', padding: '8px 12px', borderRadius: '8px' },
  content: { padding: '16px', display: 'flex', flexDirection: 'column', gap: '20px' },
  card: { background: 'white', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', overflow: 'hidden' },
  cardHeaderBlue: { padding: '16px 20px', background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)', color: 'white' },
  cardHeaderSlate: { padding: '16px 20px', background: 'linear-gradient(135deg, #475569 0%, #334155 100%)', color: 'white' },
  cardHeaderCyan: { padding: '16px 20px', background: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)', color: 'white' },
  cardBody: { padding: '16px' },
  table: { width: '100%', minWidth: '800px', borderCollapse: 'collapse', fontSize: '13px' },
  th: { padding: '12px 10px', textAlign: 'left', fontWeight: 600, color: '#334155', border: '1px solid #e2e8f0', background: '#f1f5f9', whiteSpace: 'nowrap' },
  td: { padding: '10px', border: '1px solid #e2e8f0', verticalAlign: 'middle' },
  badge: { display: 'inline-block', padding: '4px 10px', borderRadius: '20px', fontSize: '11px', fontWeight: 600, background: '#dbeafe', color: '#1e40af' },
  badgeObs: { background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)', color: 'white', marginRight: '4px' },
  emptyState: { textAlign: 'center', padding: '40px 20px', background: '#f8fafc', border: '2px dashed #e2e8f0', borderRadius: '12px', marginBottom: '16px' },
  btnAdd: { width: '100%', padding: '16px 20px', border: 'none', borderRadius: '12px', fontSize: '15px', fontWeight: 600, cursor: 'pointer', color: 'white' },
  btnBlue: { background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)' },
  btnSlate: { background: 'linear-gradient(135deg, #475569 0%, #334155 100%)' },
  btnCyan: { background: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)' },
  actions: { position: 'fixed', bottom: 0, left: 0, right: 0, display: 'flex', gap: '12px', padding: '16px', background: 'white', borderTop: '1px solid #e2e8f0', boxShadow: '0 -4px 12px rgba(0,0,0,0.1)' },
  btnSecondary: { flex: 1, padding: '14px', borderRadius: '12px', fontSize: '15px', fontWeight: 600, cursor: 'pointer', background: 'white', border: '2px solid #e2e8f0', color: '#64748b' },
  btnPrimary: { flex: 1, padding: '14px', borderRadius: '12px', fontSize: '15px', fontWeight: 600, cursor: 'pointer', background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)', border: 'none', color: 'white' },
  disjoncteurMini: { display: 'flex', flexDirection: 'column', gap: '4px', fontSize: '11px', color: '#475569' },
  miniSpan: { background: '#f1f5f9', padding: '2px 6px', borderRadius: '4px' },
  btnEditMini: { background: '#dbeafe', color: '#1e40af', border: 'none', padding: '6px 10px', borderRadius: '6px', fontSize: '12px', cursor: 'pointer', marginTop: '4px' },
  btnAddMini: { background: '#3b82f6', color: 'white', border: 'none', padding: '8px 12px', borderRadius: '6px', fontSize: '12px', cursor: 'pointer' },
  btnIcon: { background: 'none', border: 'none', cursor: 'pointer', fontSize: '18px', padding: '6px', borderRadius: '8px' },
  autonomeDisplay: { background: 'linear-gradient(135deg, #ecfeff 0%, #cffafe 100%)', border: '2px solid #06b6d4', borderRadius: '12px', padding: '16px' },
  autonomeGrid: { display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '12px', fontSize: '14px', marginBottom: '16px', color: '#0e7490' },
  btnDbr: { width: '100%', padding: '16px 20px', border: '2px solid #3b82f6', borderRadius: '12px', fontSize: '15px', fontWeight: 600, cursor: 'pointer', color: '#1e40af', background: 'linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)', marginTop: '12px' },
  dbrOverlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100, padding: '16px' },
  dbrDialog: { background: 'white', borderRadius: '16px', width: '100%', maxWidth: '420px', boxShadow: '0 20px 60px rgba(0,0,0,0.3)', overflow: 'hidden' },
  dbrDialogHeader: { padding: '16px 20px', borderBottom: '1px solid #e2e8f0' },
  dbrDialogBody: { padding: '16px 20px' },
  dbrDialogFooter: { display: 'flex', gap: '10px', padding: '16px 20px', borderTop: '1px solid #e2e8f0', background: '#f8fafc' },
  dbrInput: { width: '100%', padding: '12px 14px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '15px', boxSizing: 'border-box' }
};

// Helpers pour afficher le type de source autonome (alignement avec l'app principale)
const formatTypeSource = (type) => {
  switch (type) {
    case 'principale': return 'Principale';
    case 'secondaire': return 'Secondaire';
    case 'remplacement': return 'Source de remplacement';
    case 'securite': return 'Source de sécurité';
    default: return type || '-';
  }
};

const getSourceTypeBadge = (type) => {
  const badgeBase = { display: 'inline-block', padding: '4px 10px', borderRadius: '20px', fontSize: '11px', fontWeight: 600, color: 'white', whiteSpace: 'nowrap' };
  switch (type) {
    case 'principale':
      return <span style={{ ...badgeBase, background: '#0891b2' }}>⚡ Principale</span>;
    case 'secondaire':
      return <span style={{ ...badgeBase, background: '#d97706' }}>🔋 Secondaire</span>;
    case 'remplacement':
      return <span style={{ ...badgeBase, background: '#f97316' }}>🔄 Remplacement</span>;
    case 'securite':
      return <span style={{ ...badgeBase, background: '#16a34a' }}>🛡️ Sécurité</span>;
    default:
      return null;
  }
};

function Etape8({ mission, onBack, onSave }) {
  const [formData, setFormData] = useState({
    sources_bt: [],
    hta: null,
    source_autonome: null,
    alimentation_statique: false
  });

  // Domaine tension récupéré depuis etape_3_conditions pour conditionner l'affichage HT
  const [domaineTension, setDomaineTension] = useState('');
  const isHTA = domaineTension === 'HTA' || domaineTension === 'BT_HTA';

  const [showSourceBTModal, setShowSourceBTModal] = useState(false);
  const [showDisjoncteurModal, setShowDisjoncteurModal] = useState(false);
  const [showSourceHTModal, setShowSourceHTModal] = useState(false);
  const [showSourceAutonomeModal, setShowSourceAutonomeModal] = useState(false);
  const [showObservationModal, setShowObservationModal] = useState(false);

  const [currentSourceIndex, setCurrentSourceIndex] = useState(null);
  const [observationContext, setObservationContext] = useState(null);
  const [obsInitialPhotos, setObsInitialPhotos] = useState([]);
  const [obsPendingPhotoId, setObsPendingPhotoId] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [showDbrLocDialog, setShowDbrLocDialog] = useState(false);
  const [dbrLocDraft, setDbrLocDraft] = useState('');
  const [sourceBtModalPreset, setSourceBtModalPreset] = useState(null);
  const [disjoncteurInitialOverride, setDisjoncteurInitialOverride] = useState(null);

  useEffect(() => {
    loadSavedData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadSavedData = async () => {
    try {
      const [saved, etape3] = await Promise.all([
        inspectionStorage.getStep(mission.id, 'etape_8_sources_energie'),
        inspectionStorage.getStep(mission.id, 'etape_3_conditions')
      ]);

      if (etape3?.domaine_tension) {
        setDomaineTension(etape3.domaine_tension);
      }

      if (saved) {
        // Migration ascendante : sources_ht (tableau) -> hta (objet unique) pour aligner avec l'app principale
        let hta = saved.hta || null;
        if (!hta && Array.isArray(saved.sources_ht) && saved.sources_ht.length > 0) {
          hta = saved.sources_ht[0];
        }

        setFormData({
          sources_bt: saved.sources_bt || [],
          hta,
          source_autonome: saved.source_autonome || null,
          alimentation_statique: saved.alimentation_statique || false
        });
      }
    } catch (error) {
      console.error('Erreur chargement cache:', error);
    }
  };

  const closeSourceBTModal = () => {
    setShowSourceBTModal(false);
    setSourceBtModalPreset(null);
  };

  const handleSourceBtModalSave = (sourceData) => {
    const withDbrDisjoncteurPreset = sourceBtModalPreset != null;
    const newSourceIndex = formData.sources_bt.length;
    const newSource = { ...sourceData, disjoncteur: null, obs_ids: [] };

    setFormData(prev => ({
      ...prev,
      sources_bt: [...prev.sources_bt, newSource]
    }));

    setSourceBtModalPreset(null);
    setCurrentSourceIndex(newSourceIndex);
    setDisjoncteurInitialOverride(withDbrDisjoncteurPreset ? buildStandardEnedisDisjoncteur() : null);
    setShowSourceBTModal(false);
    setShowDisjoncteurModal(true);
  };

  const handleSaveDisjoncteur = (disjoncteurData) => {
    if (currentSourceIndex !== null) {
      setFormData(prev => {
        const newSourcesBT = [...prev.sources_bt];
        if (newSourcesBT[currentSourceIndex]) {
          newSourcesBT[currentSourceIndex] = {
            ...newSourcesBT[currentSourceIndex],
            disjoncteur: disjoncteurData
          };
        }
        return { ...prev, sources_bt: newSourcesBT };
      });
    }
    setCurrentSourceIndex(null);
  };

  const editDisjoncteur = (index) => {
    setDisjoncteurInitialOverride(null);
    setCurrentSourceIndex(index);
    setShowDisjoncteurModal(true);
  };

  const removeSourceBT = (index) => {
    if (window.confirm('Supprimer cette source BT ?')) {
      setFormData(prev => ({
        ...prev,
        sources_bt: prev.sources_bt.filter((_, i) => i !== index)
      }));
    }
  };

  const handleSaveSourceAutonome = (sourceData) => {
    setFormData(prev => ({
      ...prev,
      source_autonome: sourceData,
      alimentation_statique: true
    }));
  };

  const buildSourceContext = (source, index) => ({
    step_origin: 'etape_8_sources_energie',
    localisation: source.localisation || 'N/A',
    element: `Source BT: ${source.nature_designation || ''}`,
    element_ref: { etape: '8', type: 'source_bt', path: { source_index: index } },
  });

  const openObsModalWith = (ctx, initialPhotos = [], pendingPhotoId = null) => {
    setObservationContext(ctx);
    setObsInitialPhotos(initialPhotos);
    setObsPendingPhotoId(pendingPhotoId);
    setShowObservationModal(true);
  };

  const openObservationForSource = (source, index) => {
    openObsModalWith(buildSourceContext(source, index));
  };

  const handleQuickPhotoOpenObs = (photo, ctx) => {
    if (!photo) return;
    const url = photo.url || photo.blob_base64;
    openObsModalWith(ctx, url ? [url] : [], photo.id);
  };

  const handleCloseObsModal = () => {
    setShowObservationModal(false);
    setObservationContext(null);
    setObsInitialPhotos([]);
    setObsPendingPhotoId(null);
  };

  const handleSaveObservation = async (observationData) => {
    try {
      // Propage l'observation dans etape_11_observations comme l'app principale (numérotation auto + sync)
      const etape11Data = await inspectionStorage.getStep(mission.id, 'etape_11_observations') || {};
      const currentObservations = etape11Data.observations || [];

      const dernierNumero = currentObservations.length > 0
        ? Math.max(...currentObservations.map(o => o.numero || 0))
        : 0;
      const nouveauNumero = dernierNumero + 1;

      const observation = {
        ...observationData,
        numero: nouveauNumero,
        created_date: observationData.created_date || new Date().toISOString(),
        photos: observationData.photos || []
      };

      const obsStepData = {
        observations: [...currentObservations, observation],
        dernier_numero: nouveauNumero,
        timestamp: new Date().toISOString()
      };

      await inspectionStorage.saveStep(mission.id, 'etape_11_observations', obsStepData);
      syncManager.syncStep(mission.id, 'etape_11_observations', obsStepData);

      // Lie l'observation à la source BT correspondante
      const sourceIndex = observation.element_ref?.path?.source_index;
      if (typeof sourceIndex === 'number') {
        setFormData(prev => {
          const newSourcesBT = [...prev.sources_bt];
          if (newSourcesBT[sourceIndex]) {
            const existing = newSourcesBT[sourceIndex].obs_ids || [];
            newSourcesBT[sourceIndex] = {
              ...newSourcesBT[sourceIndex],
              obs_ids: existing.includes(nouveauNumero) ? existing : [...existing, nouveauNumero]
            };
          }
          return { ...prev, sources_bt: newSourcesBT };
        });
      }
      if (obsPendingPhotoId) {
        try {
          await pendingPhotosService.remove(mission.id, obsPendingPhotoId);
        } catch (e) {
          console.warn('[Etape8] suppression pending photo échouée :', e?.message || e);
        }
      }
    } catch (error) {
      console.error('Erreur sauvegarde observation:', error);
      alert("Erreur lors de l'enregistrement de l'observation");
    } finally {
      handleCloseObsModal();
    }
  };

  const handleSave = async () => {
    setIsSaving(true);
    try {
      await inspectionStorage.saveStep(mission.id, 'etape_8_sources_energie', formData);
      await syncManager.syncStep(mission.id, 'etape_8_sources_energie', formData);
      
      if (onSave) onSave(formData);
      alert('Étape 8 sauvegardée avec succès !');
      onBack();
    } catch (error) {
      console.error('Erreur sauvegarde:', error);
      alert('Erreur lors de la sauvegarde');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <button style={styles.backBtn} onClick={onBack}>← Retour</button>
        <div style={{textAlign: 'center'}}>
          <h1 style={{margin: 0, fontSize: '18px', fontWeight: 700, color: '#1e293b'}}>Étape 8/14</h1>
          <p style={{margin: '4px 0 0', fontSize: '13px', color: '#64748b'}}>Sources d'énergie</p>
        </div>
        <div></div>
      </div>

      <div style={styles.content}>
        {/* Sources BT */}
        <div style={styles.card}>
          <div style={styles.cardHeaderBlue}>
            <h2 style={{margin: 0, fontSize: '16px', fontWeight: 700}}>💡 Sources d'énergie basse tension enregistrées</h2>
          </div>
          <div style={styles.cardBody}>
            {formData.sources_bt.length > 0 ? (
              <div style={{overflowX: 'auto', marginBottom: '16px'}}>
                <table style={styles.table}>
                  <thead>
                    <tr>
                      <th style={styles.th}>Localisation</th>
                      <th style={styles.th}>Nature</th>
                      <th style={styles.th}>Tension (V)</th>
                      <th style={styles.th}>Puissance (kVA)</th>
                      <th style={styles.th}>Courant (A)</th>
                      <th style={styles.th}>Schéma</th>
                      <th style={styles.th}>Disjoncteur Général</th>
                      <th style={styles.th}>Obs.</th>
                      <th style={styles.th}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {formData.sources_bt.map((source, index) => (
                      <tr key={index} style={{background: index % 2 === 0 ? 'white' : '#f8fafc'}}>
                        <td style={{...styles.td, fontWeight: 600, color: '#1e293b'}}>{source.localisation || '-'}</td>
                        <td style={styles.td}>{source.nature_designation || '-'}</td>
                        <td style={styles.td}>{source.tension || '-'}</td>
                        <td style={styles.td}>{source.puissance || '-'}</td>
                        <td style={styles.td}>{source.intensite || '-'}</td>
                        <td style={styles.td}><span style={styles.badge}>{source.schema_liaison_terre || '-'}</span></td>
                        <td style={styles.td}>
                          {source.disjoncteur ? (
                            <div style={styles.disjoncteurMini}>
                              <span style={styles.miniSpan}><strong>Type:</strong> {source.disjoncteur.type}</span>
                              <span style={styles.miniSpan}><strong>Calibre:</strong> {source.disjoncteur.calibre_reglage} A</span>
                              <span style={styles.miniSpan}><strong>Pdc:</strong> {source.disjoncteur.pdc} kA</span>
                              <button style={styles.btnEditMini} onClick={() => editDisjoncteur(index)}>✏️ Éditer</button>
                            </div>
                          ) : (
                            <button style={styles.btnAddMini} onClick={() => editDisjoncteur(index)}>➕ Ajouter</button>
                          )}
                        </td>
                        <td style={styles.td}>
                          {source.obs_ids && source.obs_ids.length > 0 ? (
                            <div style={{display: 'flex', flexWrap: 'wrap', gap: '4px'}}>
                              {source.obs_ids.map(id => (
                                <span key={id} style={{...styles.badge, ...styles.badgeObs}}>{id}</span>
                              ))}
                            </div>
                          ) : <span style={{color: '#94a3b8'}}>-</span>}
                        </td>
                        <td style={styles.td}>
                          <div style={{display: 'flex', gap: '8px', justifyContent: 'center'}}>
                            <button style={{...styles.btnIcon, background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)', borderRadius: '8px'}} onClick={() => openObservationForSource(source, index)}>⚠️</button>
                            <QuickPhotoButton
                              missionId={mission?.id}
                              context={buildSourceContext(source, index)}
                              onOpenObservation={handleQuickPhotoOpenObs}
                              title="Prendre une photo de la source"
                            />
                            <button style={styles.btnIcon} onClick={() => removeSourceBT(index)}>🗑️</button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div style={styles.emptyState}>
                <div style={{fontSize: '48px', marginBottom: '12px'}}>💡</div>
                <p style={{color: '#64748b', fontSize: '14px', margin: 0}}>Aucune source basse tension enregistrée</p>
              </div>
            )}
            <button
              style={{...styles.btnAdd, ...styles.btnBlue}}
              onClick={() => {
                setSourceBtModalPreset(null);
                setShowSourceBTModal(true);
              }}
            >
              ➕ Ajouter une source Basse Tension
            </button>
            <button
              type="button"
              style={styles.btnDbr}
              onClick={() => {
                setDbrLocDraft('');
                setShowDbrLocDialog(true);
              }}
            >
              ✨ Source DBR standard (Enedis)
            </button>
          </div>
        </div>

        {/* Sources HT - visible uniquement si domaine_tension = HTA ou BT_HTA */}
        {isHTA && (
          <div style={styles.card}>
            <div style={styles.cardHeaderSlate}>
              <h2 style={{margin: 0, fontSize: '16px', fontWeight: 700}}>⚡ Sources d'énergie haute tension</h2>
            </div>
            <div style={styles.cardBody}>
              {formData.hta ? (
                <div style={{background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '12px', overflow: 'hidden', marginBottom: '16px'}}>
                  <div style={{background: '#475569', color: 'white', padding: '10px 16px', fontWeight: 600}}>📍 {formData.hta.caracteristiques?.localisation || 'Poste HT'}</div>
                  <div style={{padding: '12px 16px', fontSize: '13px'}}>
                    <p style={{margin: '4px 0', color: '#475569'}}><strong>Désignation:</strong> {formData.hta.caracteristiques?.designation || '-'}</p>
                    <p style={{margin: '4px 0', color: '#475569'}}><strong>Type:</strong> {formData.hta.caracteristiques?.type_poste || '-'}</p>
                    <p style={{margin: '4px 0', color: '#475569'}}><strong>Tension:</strong> {formData.hta.caracteristiques?.tension_alimentation || '-'} V</p>
                  </div>
                </div>
              ) : (
                <div style={styles.emptyState}>
                  <div style={{fontSize: '48px', marginBottom: '12px'}}>⚡</div>
                  <p style={{color: '#64748b', fontSize: '14px', margin: 0}}>Aucune source haute tension enregistrée</p>
                </div>
              )}
              <button style={{...styles.btnAdd, ...styles.btnSlate}} onClick={() => setShowSourceHTModal(true)}>
                ⚡ {formData.hta ? 'Gérer la source Haute Tension' : 'Ajouter une source Haute Tension'}
              </button>
            </div>
          </div>
        )}

        {/* Source Autonome */}
        <div style={styles.card}>
          <div style={styles.cardHeaderCyan}>
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '12px'}}>
              <h2 style={{margin: 0, fontSize: '16px', fontWeight: 700}}>🔋 SOURCE AUTONOME</h2>
              {formData.source_autonome && getSourceTypeBadge(formData.source_autonome.type_source)}
            </div>
          </div>
          <div style={styles.cardBody}>
            {formData.source_autonome ? (
              <div style={styles.autonomeDisplay}>
                <div style={styles.autonomeGrid}>
                  <div><strong>Type:</strong> {formatTypeSource(formData.source_autonome.type_source)}</div>
                  <div><strong>Localisation:</strong> {formData.source_autonome.localisation}</div>
                  <div><strong>Désignation:</strong> {formData.source_autonome.designation}</div>
                  <div><strong>Nature:</strong> {formData.source_autonome.nature_source}</div>
                  <div><strong>Marque:</strong> {formData.source_autonome.marque}</div>
                  {formData.source_autonome.numero && (
                    <div><strong>N°:</strong> {formData.source_autonome.numero}</div>
                  )}
                  <div><strong>Puissance:</strong> {formData.source_autonome.puissance} kVA</div>
                  <div><strong>Tension:</strong> {formData.source_autonome.tension} V</div>
                  {formData.source_autonome.intensite && (
                    <div><strong>Intensité:</strong> {formData.source_autonome.intensite} A</div>
                  )}
                  {formData.source_autonome.dielectrique_ucc && (
                    <div><strong>Ucc:</strong> {formData.source_autonome.dielectrique_ucc} %</div>
                  )}
                  <div><strong>Schéma:</strong> {formData.source_autonome.schema_liaison_terre}</div>
                </div>
                {formData.source_autonome.installations_alimentees && (
                  <div style={{marginTop: '12px', padding: '8px 12px', background: 'white', borderRadius: '8px', fontSize: '13px', color: '#0e7490'}}>
                    <strong>Installations alimentées:</strong> {formData.source_autonome.installations_alimentees}
                  </div>
                )}
                {formData.source_autonome.protection_secondaire && (
                  <div style={{marginTop: '8px', padding: '8px 12px', background: 'white', borderRadius: '8px', fontSize: '13px', color: '#0e7490'}}>
                    <strong>Protection secondaire:</strong> {formData.source_autonome.protection_secondaire}
                  </div>
                )}
                <button style={{marginTop: '12px', background: 'white', border: '2px solid #06b6d4', color: '#0891b2', padding: '10px 16px', borderRadius: '8px', fontSize: '14px', fontWeight: 600, cursor: 'pointer'}} onClick={() => setShowSourceAutonomeModal(true)}>✏️ Modifier</button>
              </div>
            ) : (
              <button style={{...styles.btnAdd, ...styles.btnCyan}} onClick={() => setShowSourceAutonomeModal(true)}>⚡ Configurer une source autonome</button>
            )}
          </div>
        </div>
      </div>

      <div style={styles.actions}>
        <button style={styles.btnSecondary} onClick={onBack} disabled={isSaving}>Annuler</button>
        <button style={{...styles.btnPrimary, opacity: isSaving ? 0.6 : 1}} onClick={handleSave} disabled={isSaving}>
          {isSaving ? '💾 Sauvegarde...' : '💾 Sauvegarder et continuer'}
        </button>
      </div>

      {showDbrLocDialog && (
        <div style={styles.dbrOverlay} onClick={() => setShowDbrLocDialog(false)}>
          <div style={styles.dbrDialog} onClick={(e) => e.stopPropagation()}>
            <div style={styles.dbrDialogHeader}>
              <h2 style={{ margin: 0, fontSize: '17px', fontWeight: 700, color: '#1e293b' }}>Localisation — source DBR standard</h2>
            </div>
            <div style={styles.dbrDialogBody}>
              <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: 600, color: '#334155' }}>Localisation *</label>
              <input
                style={styles.dbrInput}
                value={dbrLocDraft}
                onChange={(e) => setDbrLocDraft(e.target.value)}
                placeholder="Ex. placard technique, local électrique…"
              />
            </div>
            <div style={styles.dbrDialogFooter}>
              <button type="button" style={{ ...styles.btnSecondary, flex: 1 }} onClick={() => setShowDbrLocDialog(false)}>Annuler</button>
              <button
                type="button"
                style={{ ...styles.btnPrimary, flex: 1, background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)' }}
                onClick={() => {
                  const loc = dbrLocDraft.trim();
                  if (!loc) {
                    alert('La localisation est obligatoire.');
                    return;
                  }
                  setSourceBtModalPreset(buildStandardEnedisSourceBT(loc));
                  setShowDbrLocDialog(false);
                  setShowSourceBTModal(true);
                }}
              >
                Continuer
              </button>
            </div>
          </div>
        </div>
      )}

      {showSourceBTModal && (
        <SourceBTModalMobile
          isOpen={showSourceBTModal}
          onClose={closeSourceBTModal}
          onSave={handleSourceBtModalSave}
          initialPreset={sourceBtModalPreset}
        />
      )}

      {showDisjoncteurModal && (
        <DisjoncteurModalMobile
          key={`dj-${currentSourceIndex}-${disjoncteurInitialOverride ? 'pre' : 'edit'}`}
          isOpen={showDisjoncteurModal}
          onClose={() => {
            setShowDisjoncteurModal(false);
            setCurrentSourceIndex(null);
            setDisjoncteurInitialOverride(null);
          }}
          onSave={handleSaveDisjoncteur}
          initialData={
            disjoncteurInitialOverride != null
              ? disjoncteurInitialOverride
              : (currentSourceIndex !== null ? formData.sources_bt[currentSourceIndex]?.disjoncteur : null)
          }
        />
      )}

      {showSourceHTModal && (
        <SourceHTModalMobile
          isOpen={showSourceHTModal}
          onClose={() => setShowSourceHTModal(false)}
          onSave={(htData) => setFormData(prev => ({ ...prev, hta: htData }))}
          initialData={formData.hta}
        />
      )}

      {showSourceAutonomeModal && (
        <SourceAutonomeModalMobile
          isOpen={showSourceAutonomeModal}
          onClose={() => setShowSourceAutonomeModal(false)}
          onSave={handleSaveSourceAutonome}
          initialData={formData.source_autonome}
        />
      )}

      {showObservationModal && (
        <ObservationModal
          isOpen={showObservationModal}
          onClose={handleCloseObsModal}
          onSave={handleSaveObservation}
          context={observationContext}
          initialPhotos={obsInitialPhotos}
          mission={mission}
          missionId={mission?.id}
        />
      )}
    </div>
  );
}

export default Etape8;